'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var MaterialTableCell = _interopDefault(require('@material-ui/core/TableCell'));

var StyledTableCell = styled__default(MaterialTableCell)(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  &.root {\n    font-size: ", ";\n    font-family: ", ";\n    line-height: 22px;\n    color: ", ";\n    border-right: 1px solid ", ";\n  }\n\n  &.head {\n    font-weight: bold;\n    background-color: ", ";\n  }\n\n  &.root:last-of-type {\n    border-right: 0 none;\n  }\n"], ["\n  &.root {\n    font-size: ", ";\n    font-family: ", ";\n    line-height: 22px;\n    color: ", ";\n    border-right: 1px solid ", ";\n  }\n\n  &.head {\n    font-weight: bold;\n    background-color: ", ";\n  }\n\n  &.root:last-of-type {\n    border-right: 0 none;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fontSizes.sm;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyMedium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
});
var TableCell = function (_a) {
    var children = _a.children, restProps = tslib_es6.__rest(_a, ["children"]);
    return (React__default.createElement(StyledTableCell, tslib_es6.__assign({}, restProps, { classes: { root: 'root', head: 'head' } }), children));
};
var templateObject_1;

exports.TableCell = TableCell;
